/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class CustomerListMeta {
  totalSize: number | undefined = undefined;
  customerStageOptions: string[] | undefined = undefined;
  customerLoyaltyOptions: string[] | undefined = undefined;
  creditStatusOptions: string[] | undefined = undefined;

  constructor() {
    this.totalSize = 0;
    this.customerStageOptions = [];
    this.customerLoyaltyOptions = [];
    this.creditStatusOptions = [];
  }
}
